import {Component, ElementRef, ViewChild} from '@angular/core';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {PaginatorComponent} from '../../../shared/paginator';
import {MatSort} from '@angular/material/sort';
import {AppLoaderComponent} from '../../../shared/app-loader/app-loader.component';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';

@Component({
   selector: 'app-promotion-list',
   templateUrl: './promotion-list.component.html',
   styleUrls: ['./promotion-list.component.css']
})
export class PromotionListComponent {

   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   @ViewChild('btnDelSite', {static: true}) public buttonDel: MatButton;
   isLoadingResults = true;
   listPackage = [
      {
         "id": "00001",
         "promoCode": "zdox-promo-00001",
         "promoName": "ผู้ใช้งานใหม่ {New User}",
         "discountCode": "NEWZDOX",
         "promoPeriod": "ไม่มีวันหมดอายุ",
         "maximumPromo": "ไม่จำกัด",
         "status": "ใช้งาน",
         "promoDiscount": "5%",
         "maximumDiscount": "1000"
      },
      {
         "id": "00002",
         "promoCode": "zdox-promo-00002",
         "promoName": "เทศกาลปัใหม่",
         "discountCode": "NY2023",
         "promoPeriod": "20/18/2022 - 10/01/2023",
         "maximumPromo": "200/1000 สิทธิ์",
         "status": "ไม่ใช้งาน",
         "promoDiscount": "10%",
         "maximumDiscount": "2000"
      },
   ];
   selectedRowIndex = -1;
   displayedColumns = ['no', 'promo_code', 'promo_name', 'discount_code', 'promo_period', 'maximum_promo', 'status', 'promo_discount', 'maximum_discount' , 'menu'];
   dataSource: MatTableDataSource<PackageData>;

   constructor() {
      // This is intentional
   }

   openPromotionDialog(isEdit: boolean) {
      // This is intentional
   }
}

export interface PackageData {
   id: number;
   itemCode: string;
   itemName: string;
   itemType: string;
   unit: string;
   price: string;
   discountPrice: string;
}
